/* eslint-disable import/no-cycle */
import React, { useRef, useState } from 'react'

import { useTranslation } from 'react-i18next'
import Slider from 'react-slick'

import PauseIcon from 'assets/PauseIcon.svg'
import PlayIcon from 'assets/PlayIcon.svg'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import Button from 'components/button'
import CONFIG from 'config'
import { isEmpty } from 'helpers/utils'

import {
  Image,
  Info,
  InfoContainer,
  Logo,
  Title,
  Subtitle,
  Description,
  ButtonContainer,
  Wrapper,
  ImageLink,
  PauseBtnContainer
} from './styled'

const DefaultCarousel = ({
  data,
  withSearchBox,
  infoRef,
  isDarkSiteEnabled,
  isMobile,
  isLanding
}) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  }

  const { t } = useTranslation()

  const [autoPlayOn, setAutoPlayOn] = useState(false)
  const sliderRef = useRef(null)
  const sliderElement = sliderRef.current

  return (
    <Wrapper isLanding={isLanding} withSearchBox={withSearchBox}>
      {!isEmpty(data) && typeof window !== 'undefined' ? (
        <Slider ref={sliderRef} {...settings}>
          {data.map((item, index) => (
            <div key={index}>
              <ImageLink
                href={item.url || null}
                withSearchBox={withSearchBox}
                role="banner"
                aria-label={item.alt}
                dataPosition={index + 1}
                dataDescription={item.dataDescription}
                dataSection={item.dataSection}
              >
                <Image
                  hasImage={item.image}
                  src={`
                  ${CONFIG.CONTENT_CDN_BASE_URL}${
                    isMobile && item.imageResponsive ? item.imageResponsive : item.image
                  }`}
                  alt={item.alt}
                />
                <InfoContainer
                  ref={infoRef}
                  isDarkSiteEnabled={isDarkSiteEnabled}
                  isMobile={isMobile}
                  isLanding={isLanding}
                  isMultipleSlide={data.length > 1}
                >
                  {(!isLanding || data.length > 1) && (
                    <PauseBtnContainer>
                      <Button
                        white
                        small
                        isCarousel
                        hoverColor="none"
                        onClick={e => {
                          e.preventDefault()
                          e.stopPropagation()
                          setAutoPlayOn(!autoPlayOn)
                          if (sliderElement) {
                            if (autoPlayOn) {
                              sliderRef.current.slickPlay()
                            } else {
                              sliderRef.current.slickPause()
                            }
                          }
                        }}
                      >
                        <img
                          src={autoPlayOn ? PlayIcon : PauseIcon}
                          alt={!autoPlayOn ? t('alt.carousel-pause') : t('alt.carousel-play')}
                        />
                      </Button>
                    </PauseBtnContainer>
                  )}
                  <Info isMobile={isMobile}>
                    {item.showTitle && (
                      <Title isDarkSiteEnabled={isDarkSiteEnabled}>{item.title}</Title>
                    )}
                    {item.subtitle && <Subtitle>{item.subtitle}</Subtitle>}
                    {item.logo && (
                      <Logo
                        width={item.logoWidth}
                        heigth={item.logoHeigth}
                        src={`${CONFIG.CONTENT_CDN_BASE_URL}${item.logo}`}
                      />
                    )}
                    <Description dangerouslySetInnerHTML={{ __html: item.description }} />
                    <ButtonContainer>
                      {item.buttonName ? (
                        <Button
                          white
                          small
                          onClick={e => {
                            e.stopPropagation()
                            e.preventDefault()
                            window.location = item.buttonUrl || item.url
                          }}
                          dangerouslySetInnerHTML={{ __html: item.buttonName }}
                        />
                      ) : null}
                    </ButtonContainer>
                  </Info>
                </InfoContainer>
              </ImageLink>
            </div>
          ))}
        </Slider>
      ) : (
        <ImageLink>
          <Image />
        </ImageLink>
      )}
    </Wrapper>
  )
}

export default DefaultCarousel
